import React from 'react'

const Phone = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1029 5H17.8992C19.0581 5 20 5.98408 20 7.19738V20.8004C20 22.0137 19.0581 23 17.8992 23H10.1029C8.94293 23 8 22.0148 8 20.8004V7.19738C8 5.98408 8.94188 5 10.1029 5ZM14.2694 21.3259C14.8217 21.3259 15.2694 20.8782 15.2694 20.3259C15.2694 19.7736 14.8217 19.3259 14.2694 19.3259C13.7172 19.3259 13.2694 19.7736 13.2694 20.3259C13.2694 20.8782 13.7172 21.3259 14.2694 21.3259Z"
        fill="#1072EB"
      />
    </svg>
  )
}

export default Phone
